import React, {Component} from 'react';

import axios from 'axios';
import {  Link,withRouter } from "react-router-dom";
//import ReactImageMagnify from 'react-image-magnify';
import { Alert } from 'reactstrap';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import Toggle from "react-toggle-component"
import "react-toggle-component/styles.css"
import Modal from 'react-responsive-modal';
//import Modal from 'react-modal';

import LostItemPicker from '../LostItemPicker/LostItemPicker'
import DatePicker from "react-datepicker";
import {SERVER_URL}  from '../Constants';
import "react-datepicker/dist/react-datepicker.css";
import  ClaimShipment from '../Shipments/ClaimShipment';
import ReturnWizard2 from '../Shipments/ReturnWizard2';
import ClaimFormatterFunctions from '../Claims/ClaimFormatters';
import ReactImageMagnify from 'react-image-magnify';


//const airports = require('../Portal/Airports.json'); // use this for auto-complete
//const cats = require('../Portal/Categories.json');
const stateAbbreviations = [' ',
  'AL','AK','AS','AZ','AR','CA','CO','CT','DE','DC','FM','FL','GA',
  'GU','HI','ID','IL','IN','IA','KS','KY','LA','ME','MH','MD','MA',
  'MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND',
  'MP','OH','OK','OR','PW','PA','PR','RI','SC','SD','TN','TX','UT',
  'VT','VI','VA','WA','WV','WI','WY'
 ];

 const colors = ['','Clear','Beige', 'Black','Blue','Brown','Camo','Gold','Green','Grey','Orange','Pink', 'Purple', 'Red', 'Silver','Turquoise','White','Yellow', 'Violet'];




class Claim extends Component {
  constructor(props) {
    super(props);

    //console.log(this.props.match.params.showshipping);
    //console.log(this.props.location.search)
    
    
    const { match: { params } } = this.props;
    var claimid= '';
    if (this.props.claimId) {
      claimid = this.props.claimId;
    }else if (params.claimId){
      claimid = params.claimId;
    }
    var lostItemId = (this.props.match.params.lostItemId) ? this.props.match.params.lostItemId: this.props.lostItemId;
   // let displayShippingOnLoad = (this.props.location.search && this.props.location.search.indexOf('showshipping')>0 && lostItemId);
    this.state = {
      claim:null,
      lostItem: null,
      venueId:auth0Client.getActiveVenuedId(),
      claimId: claimid,
      updatedDate:'',
      claimDate:new Date(),
      //lostItemId: (this.props.match.params.lostItemId) ? this.props.match.params.lostItemId : '',
      lostItemId: (lostItemId) ? lostItemId : '',
      status: 'O',
      firstName: '',
      lastName: '',
      phone:'',
      email:'',
      details:'',
      claimSource:'INTERNAL',
      pickupDate:undefined,
      shipDate:undefined,
      disabled :false,
      showSuccess: false,
      showLostItemPicker: false,
      shippingAddress:'',
      shippingAddress2:'',
      shippingCity:'',
      shippingPostalCode:'',
      shippingState:'',
      shippingCountry:'US',
      locationLost:'',
      showOpenShipment:false,
      disableRequestShippingLabel : (lostItemId=== undefined || claimid===undefined || claimid==='') ? true : false,
      showNewReturn: false,
      claimNotificationButtonTitle: 'Send Claim Notification',
      isVIP: false,
      category:'',
      subcat:undefined,
      brand:undefined,
      color:'',
      filterdSubItems: [{"name": "NA"}],
      section:'',
      row:'',
      parkingLot:'',
      venueTypeCd:'',
      airportCd:'',
      seat:'',
      flightNumber: '',
      terminal:'',
      gate:'',
      travelDate: new Date(),
      totalMatches:0,
      removeLinkedItemEnabled:false,
      categoriesMap:[],
      note:'',
      archiveReason:'',
      registeredGuestName:'',
      returnImageUrl:'',
      displayLargeImageModal:false,
      displaySendNotificationModal:false,
      includeImage:false,
      largeImageUrl:'',
      isReviewed:false,
      reviewedAt:undefined,
      picUrl:'',
    };


    

  }




  

  async componentDidMount() {

    try {
      this.loadCategories();
   
    //const { match: { params } } = this.props;
    this.setState({
      venueTypeCd:auth0Client.getDefaultVenue().venueTypeCd

    })     
    //console.log(this.state.claimId);
    if (this.state.claimId && this.state.claimId!=='-1'){

        const claimItem = (await axios.get(`${SERVER_URL}/Claims/${this.state.claimId}`,
         {headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }}
      )).data; 
        
        if (!claimItem){
          ToastStore.error("Claim did not load correctly, please try again");
          return;
        }
       
        this.setState({
            claim : claimItem,
            claimId: claimItem.id,
            updatedDate:claimItem.updatedDate,
            claimDate: (claimItem.claimDate) ? new Date(claimItem.claimDate) : new Date(),//Date.parse(claimItem.claimDate),
            status: claimItem.status,
            firstName: claimItem.firstName,
            lastName: claimItem.lastName,
            phone:claimItem.phone,
            email:claimItem.email,
            lostItemId: claimItem.lostItemId,
            details: claimItem.details,
            claimSource:claimItem.claimSource,
            pickupDate:(claimItem.pickupDate) ? new Date(claimItem.pickupDate) : undefined,
            shipDate:(claimItem.shipDate) ? new Date(claimItem.shipDate) : undefined,
            address:claimItem.address,
            shippingAddress: claimItem.shippingAddress,
            shippingAddress2: claimItem.shippingAddress2,
            shippingCity: claimItem.shippingCity,
            shippingState: claimItem.shippingState,
            shippingPostalCode: claimItem.shippingPostalCode,
            shippingCountry:claimItem.shippingCountry,
            locationLost:(claimItem.locationLost) ? claimItem.locationLost : '',
            shipments: claimItem.shipments,
            isVIP: claimItem.isVIP,
            category:claimItem.category,
            subcat:claimItem.subcat,
            brand:claimItem.brand,
            color:claimItem.color,
            section:claimItem.section,
            row:claimItem.row,
            parkingLost:claimItem.parkingLost,
            airportCd:claimItem.airportCd,
            seat:claimItem.seat,
            flightNumber:claimItem.flightNumber,
            terminal:claimItem.terminal,
            gate:claimItem.gate,
            disableRequestShippingLabel: (claimItem.lostItemId!==undefined) ? false: true,
            signUrl:claimItem.signUrl,
            travelDate:(claimItem.travelDate) ? new Date(claimItem.travelDate) : undefined, //new Date(),
            totalMatches: claimItem.totalMatches,
            note:claimItem.note,
            archiveReason:claimItem.archiveReason,
            registeredGuestName:claimItem.registeredGuestName,
            returnImageUrl:claimItem.returnImageUrl,
            isReviewed:claimItem.isReviewed,
            reviewedAt:claimItem.reviewedAt,
            picUrl:claimItem.picUrl,
        });
        //console.log(claimItem.subcat);
        if (claimItem.lostItemId && !this.props.isModalDisplay ){
            this.loadLostItemById(claimItem.lostItemId );
           
        }

        this.setSubCategoryItems(claimItem.category);


    }else{
        if ( this.state.lostItemId ){
            this.loadLostItemById( this.state.lostItemId );
           
        }
       
    }
  }catch(e){
    console.log(e)
  }
   
  }

  formatDate=(dateString)=>{
    var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return new Date(dateString).toLocaleDateString([],options);
  }
  
    
  loadCategories = ()=>{
    try {
      axios.get(`${SERVER_URL}/Reports/reportCategories`,{
         headers: { 
           'Authorization': `Bearer ${auth0Client.getIdToken()}`,
           'venueId' : auth0Client.getActiveVenuedId()
         }
        
        }).then((res)=>{
         
         if (res.status===undefined || res.status !==200) {
           //place your reentry code
           console.log("Error" + res.status);
           ToastStore.error("An error occured. Please try again");
          }
 
         const categoriesMap = res.data.categoriesMap;
         // add a blank option
         categoriesMap.unshift({ "name": " ","subcat" : [ ]});
      
         this.setState({
          categoriesMap : categoriesMap,
          
          });


        },
        (error)=>{
          if (error.response && error.response.status === 401){
            ToastStore.error("Not Authorized, Please log out and log in again: " + error.message);
          }else {
            ToastStore.error('An error occured:' + error.message);
          }
          
        }
        );
    }catch(e){
        //console.log(e);
        ToastStore.error('An error occured:' + e.message);
    }


 }
   
      
  loadLostItemById=async(lostItemId)=>{
    const lostItem = (await axios.get(`${SERVER_URL}/LostItems/${lostItemId}`, {headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }})).data; 
    
    if (lostItem){
      let canRemove = false;
      canRemove = (this.state.claimId && (this.state.status==='O' || this.state.status==='A') && lostItem.itemState==='Q');
        this.setState({
            url: lostItem.url,
            shortDescription: lostItem.shortDescription,
            itemState:lostItem.itemState,
            removeLinkedItemEnabled: canRemove,
        })
    }
  }
  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }


  submit=async()=>{

    if (!await this.validate()){
      return;
    }

    this.setState({
      disabled: true,
    });
    
    await axios.post(`${SERVER_URL}/Claims/`, {
        id:(this.state.claimId==='-1') ? undefined : this.state.claimId,
        status: this.state.status,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email:this.state.email,
        address:this.state.address,
        lostItemId:this.state.lostItemId,
        phone:this.state.phone,
        details:this.state.details,
        claimDate: (this.state.claimDate) ? Date.parse(this.state.claimDate) : undefined, //Date.parse(this.state.claimDate),
        claimSource : this.state.claimSource,
        pickupDate:(this.state.pickupDate) ? Date.parse(this.state.pickupDate) : undefined,
        shipDate:(this.state.shipDate) ? Date.parse(this.state.shipDate) : undefined,
        venueId: auth0Client.getActiveVenuedId(),
        shippingAddress: this.state.shippingAddress,
        shippingAddress2: this.state.shippingAddress2,
        shippingCity: this.state.shippingCity,
        shippingState: this.state.shippingState,
        shippingPostalCode: this.state.shippingPostalCode,
        shippingCountry:this.state.shippingCountry,
        locationLost:this.state.locationLost,
        isVIP:this.state.isVIP,
        category:this.state.category,
        subcat:this.state.subcat,
        brand:this.state.brand,
        color:this.state.color,
        section:this.state.section,
        row:this.state.row,
        parkingLot:this.state.parkingLot,
        airportCd:this.state.airportCd,
        seat:this.state.seat,
        flightNumber:this.state.flightNumber,
        terminal:this.state.terminal,
        gate:this.state.gate,
        travelDate: (this.state.travelDate) ? Date.parse(this.state.travelDate) : undefined,
        note:this.state.note,
        archiveReason:this.state.archiveReason,
        registeredGuestName: this.state.registeredGuestName,
        isReviewed:this.state.isReviewed,
        reviewedAt:this.state.reviewedAt,
        picUrl:this.state.picUrl,
    }, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      
      }
    })
    .then((res)=>{
        //this.props.history.push('/');
        // Show saved successful
        if(res.status!==200){
          // console.log(JSON.stringify(res));
           ToastStore.error("An error occured: " + res.response.statusText);
           this.setState({
            showAlert:false,
            disabled: false,
            showSuccess: false,
            disableRequestShippingLabel: true,
           
  
        })
         }else{
           ToastStore.success('Claim Saved Successfully!');
           this.setState({
            showAlert:false,
            disabled: false,
            showSuccess: true,
            claimId: res.data.id,
            disableRequestShippingLabel: false,
            claim: res.data,
            totalMatches:res.data.totalMatches,  //matching update
        })
        //console.log(res.data);
         }


      
      if (this.props.refreshParent){
        this.props.refreshParent();
      }
     
    })
    .catch ((e)=>{
        
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
        ToastStore.error(this.state.error.response.data);
    })


  }


   renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}



  validate=async()=>{

    // check the short Description
    if (!this.state.lastName) {ToastStore.error('invalid or missing Last Name'); return false;}
    // check long description
    if (!this.state.firstName) {ToastStore.error('invalid or First Name'); return false;}
    
    //console.log('Claim status' + this.state.status)
    if ((this.state.status!=='O' && this.state.status!=='A') && this.state.lostItemId===''){

      ToastStore.error('CLAIM EXCEPTION: Cannot set claim status to anything other then Open or Archive until linked to a lost item');
      return false;

  }
  
    return true;


  }

  renderLargeImage=()=>{

    return(
  
   
        <Modal open={this.state.displayLargeImageModal} onClose={()=>this.setState({displayLargeImageModal:false})} center>
            <ReactImageMagnify  style={{width:700, height:600}} enlargedImagePosition='over' {...{
                                      smallImage: {
                                          alt: this.state.shortDescription,
                                          isFluidWidth: false,
                                          src: this.state.largeImageUrl,
                                          width:700,
                                          height:600
                                      },
                                      largeImage: {
                                          src: this.state.largeImageUrl,
                                          width: 1800,
                                          height: 1600
                                      },
                                      isHintEnabled: true,
                                      shouldHideHintAfterFirstActivation: false
                                  }} />
         
            <button title="Close"    className="btn btn-info" onClick={()=>{this.setState({displayLargeImageModal:false})}}>Close </button>
        </Modal>
  
        )
  }
  renderAlert=()=>{
    if (this.state.showAlert){
        
        return (
            <Alert color='danger' onDismiss={this.handleDismiss}>
            <h4>Oh snap! You got an error!</h4>
            <p>{this.state.error.response.data}</p>
          </Alert>
        );
    }

}
renderSavedSuccessAlert=()=>{
  if (this.state.showAlert){
      
      return (
          <Alert color='success' onDismiss={this.handleDismiss}>
          <h4>Oh snap! You got an error!</h4>
          <p>{this.state.error.response.data}</p>
        </Alert>
      );
  }

}
claim=()=>{
  // Show new Claim component

}
archive=()=>{

// Show archive component

}  

claimStageDesc=(claimStage)=>{
 
 return ClaimFormatterFunctions.getStatusLabel(claimStage);

}

createClaimLink=()=>{


}
handleCatChange=(event)=>{
  const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

  
    if (value===undefined || value===''){ return ;}
    //locate the filter
    let filteredItems = this.state.categoriesMap.filter(item=>{
      if (item.name.toUpperCase() === value.toUpperCase()){
        return item;
      }else{
        return null;
      }
    });
    let subCatCopy = [];
    if (filteredItems.length >0){
      subCatCopy= filteredItems[0].subcat.map((x) => x);
    }
    
    // add a blank option
    subCatCopy.unshift({ "name": " "});
    this.setState({
      [name]: value,
      filterdSubItems :  (filteredItems.length >0 ) ? subCatCopy : [],
    });
}

setSubCategoryItems=(catValue)=>{
   //locate the filter

   if (catValue===undefined || catValue===''){ return ;}

   let filteredItems = this.state.categoriesMap.filter(item=>{
    if (item.name.toUpperCase() === catValue.toUpperCase()){
      return item;
    }else{  return null; }
  });
  let subCatCopy = [];
    if (filteredItems.length >0){
      subCatCopy= filteredItems[0].subcat.map((x) => x);
    }
    
    // add a blank option
    subCatCopy.unshift({ "name": " "});

  this.setState({
    filterdSubItems : subCatCopy
  });

}


onClaimDateChange = date => this.setState({ claimDate :date });
onPickupDateChange = date => this.setState({ pickupDate :date });
onShipDateChange = date => this.setState({ shipDate :date });
ontravelDateChange = date => this.setState({ travelDate :date });

unlinkLostItem=()=>{
  if (this.state.removeLinkedItemEnabled){
    this.setState({
      lostItemId:'', 
      url:'', 
      shortDescription:''
    });
    alert('Item has been unlinked, click update to save changes');
  }else{
    alert('Cannot remove this lost item. The lost item is in process of being returned or returned. Change the status of the lost item to unclaimed and return to this screen to unlink');
  }
}

renderHeader=()=>{
    if (this.state.lostItemId){
        var url = '/LostItem/' + this.state.lostItemId;
        return (
          <div>
            <Link to={url}>{this.state.shortDescription}</Link> 
            <button type="button" onClick={()=>{this.unlinkLostItem()}} className="btn btn-link " >Unlink</button>
            </div>
        

        )
    }else{
        return(
            <button
            disabled={this.state.disabled || auth0Client.lfReadOnly===true}
            className="btn btn-success btn-sm"
            onClick={() => {this.onOpenModal()}}>
            Link Found Item...
          </button>

        );
    }
}

onOpenModal = () => {
    this.setState({ showLostItemPicker: true });
  };
 
  onCloseModal = () => {
    this.setState({ showLostItemPicker: false });
  };

  onOpenShippingModal = () => {
    this.setState({ showOpenShipment: true });
  };
 
  onCloseShippingModal = () => {
    this.setState({ showOpenShipment: false });
  };


  createReturn=()=>{

 

    // Show new Return component
    if (this.state.claimId!==-1){
      //console.log('return button');
        this.setState({
          showNewReturn: true,
        })
    }else{
      // Need to save first
      ToastStore.error("The claim item must be saved prior to creating a Return");
    }
  }
  

  assignLostItemId=async (lostItemId)=>{
        this.setState({lostItemId:lostItemId, showLostItemPicker: false});
        this.loadLostItemById(lostItemId);
  }


  renderGoBack =()=>{
    if (this.props.isModalDisplay){
      return ( null);
  }else{
    return (
      <button className="btn btn-secondary" onClick={() => this.props.history.goBack()}><h5> BACK </h5></button>
    )
   
  }
  }

  ship=async()=>{
    // First check if the fields are ok
    if (!this.validateForShip()){

    }

    this.setState({
      showOpenShipment: true
    })

    /*await axios.post(`${SERVER_URL}/Shipping/CreateShipment`, {
      id:this.state.claimId,
      status: this.state.status,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email:this.state.email,
      address:this.state.address,
      lostItemId:this.state.lostItemId,
      phone:this.state.phone,
      details:this.state.details,
      claimDate: Date.parse(this.state.claimDate),
      claimSource : this.state.claimSource,
      pickupDate:(this.state.pickupDate) ? Date.parse(this.state.pickupDate) : undefined,
      shipDate:(this.state.shipDate) ? Date.parse(this.state.shipDate) : undefined,
      venueId: auth0Client.getActiveVenuedId(),
      shippingAddress: this.state.shippingAddress,
      shippingAddress2: this.state.shippingAddress2,
      shippingCity: this.state.shippingCity,
      shippingState: this.state.shippingState,
      shippingPostalCode: this.state.shippingPostalCode,
      shippingCountry:this.state.shippingCountry,
      locationLost:this.state.locationLost

  }, {
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId()
    
    }
  })
  .then((res)=>{
    if (res.status!==200){
      
      ToastStore.error("An error occured during the creation of the shipping label.  Support will review the logs.  Please try again.");
    }else{
      ToastStore.success('Claim Saved Successfully!');
    }
      //this.props.history.push('/');
      // Show saved successful
      this.setState({
        showAlert:false,
        disabled: false,
        showSuccess: true,

    })
    if (this.props.refreshParent){
      this.props.refreshParent();
    }
    
  })
  .catch ((e)=>{
      console.error(e);
      this.setState({
          showAlert:true,
          disabled: false,
          error:e,

      })
      ToastStore.error(this.state.error.response.data);

  })*/


  }

  validateForShip=async()=>{

      // check the short Description
      if (!this.state.lastName) {ToastStore.error('Missing Last Name'); return false;}
      // check long description
      if (!this.state.firstName) {ToastStore.error('Missing First Name'); return false;}
      // check Email
      if (!this.state.email) {ToastStore.error('Missing Email'); return false;}
      // check ship address
      if (!this.state.shippingAddress) {ToastStore.error('Missing shipping Address'); return false;}
      // check ship city
      if (!this.state.shippingCity) {ToastStore.error('Missing shipping City'); return false;}
      // check ship State
      if (!this.state.shippingState) {ToastStore.error('Missing shipping State'); return false;}
      // check ship postal
      if (!this.state.shippingPostalCode) {ToastStore.error('Missing shipping Postal Code'); return false;}
      // check ship postal
      if (!this.state.shippingCountry) {ToastStore.error('Missing shipping Country'); return false;}


    

    return true;


  }

  /*getUrlParameter=(name, location)=> {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};*/

  printShipping=(url)=>{

    // check if expired, by checking the URL param called &Expires=  i.e. 1616079625
    /*if (url){
     var expirationSerial = this.getUrlParameter('Expires',url);
     var expDate = moment(new Date(expirationSerial * 1000));
     //console.log(expDate);
     var today = moment(new Date());
     var daysDiff =  expDate.diff(today,'days');
    //console.log(daysDiff);
     
    }*/
    //console.log(url);
      window.open(url);
  }

  



  sendNotification=async()=>{
    if (!this.state.email){
      ToastStore.error('Missing email address'); 
      return;
    }

    if (!window.confirm("You are about to send a Claim Received Email.  This email will notify them you have received their claim report. Ok to send?")){
      return;
    }


    this.setState({
      disabled: true,
    });

     axios.post(`${SERVER_URL}/Claims/SendClaimNotificationEmail/`, {
          id:this.state.claimId
         

    }, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      
      }
    })
    .then((res)=>{
        //this.props.history.push('/');
        // Show saved successful
        if(res.status!==200){
         // console.log(JSON.stringify(res));
          ToastStore.error("An error occured: " + res.response.statusText);
        }else{
          ToastStore.success('Claim Notification Sent Successfully!');
        }
        //console.log('response: ' + res);
        this.setState({
          showAlert:false,
          disabled: false,
          showSuccess: true,

      })
     
     
    })
    .catch ((e)=>{
        
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,

        })
        ToastStore.error(this.state.error.message);
    }) 
  }
  
  renderSendNotificationButton=(claimItem)=>{
    
    var disabled =  (!claimItem || !claimItem.email ||!claimItem.id) ;
      return(
        <button
        disabled= {disabled}                  
        className="btn btn-info"
       
        onClick={() => {this.sendNotification()}}>
        Send Claim Recv. Email
      </button>
      )
    

  }


  renderSendNotificationDialogue=()=>{
    
    
    
    return(
    
        <Modal open={this.state.displaySendNotificationModal} onClose={()=>this.setState({displaySendNotificationModal:false})} center>
            <div className='row'>
              <div className='col text-center'>
                    <h4>Send Notification</h4>
                    <br/>
                    <p className='text-primary'><b>Send an e-mail to notifying the person in this claim their item has been found.</b></p>
                    <p className='text-info'><b>Email:  {this.state.email} </b></p>

                   
              </div>
              <hr/>
            </div>
            <br/>
            <div className='row'>
              <div className='col'>
                  <label htmlFor='includeEmailToggle'>
                  <Toggle id='includeEmailToggle'  checked={this.state.includeImage} onToggle={value => this.setState({includeImage:value})} /> 
                  <b>&nbsp; Include the found item image in email</b>
                  </label>
                 
                  
              </div>
            </div>
            <br/>
            <br/>
            <div className='row'>
          
              <div className='col-6 text-left'>
                <button className='btn btn-secondary' onClick={()=>{this.setState({displaySendNotificationModal:false})}}> close</button>
              </div>
              <div className='col-6 text-right'>
                <button className='btn btn-primary' disabled={!this.state.email} onClick={()=>this.sendFoundNotification()}>Send Now {(this.state.includeImage) ? " With Image" : ""}</button>
              </div>

            </div>

            
           
         
        </Modal>
     
    )
  }


  sendFoundNotification=()=>{
    if (!this.state.email){
      ToastStore.error('Missing email address'); 
      return;
    }

    
    this.setState({
      disabled: true,
    });

     axios.post(`${SERVER_URL}/Claims/SendClaimFoundItemNotificationEmail/`, {
          id:this.state.claimId,
          includeImage: this.state.includeImage

    }, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      
      }
    })
    .then((res)=>{
        //this.props.history.push('/');
        // Show saved successful
        if(res.status!==200){
         // console.log(JSON.stringify(res));
          ToastStore.error("An error occured: " + res.response.statusText);
        }else{
          ToastStore.success('Email Sent Successfully!');
        }
        //console.log('response: ' + res);
        this.setState({
          showAlert:false,
          disabled: false,
          showSuccess: true,
          displaySendNotificationModal:false,

      })
     
     
    })
    .catch ((e)=>{
        
        this.setState({
            showAlert:true,
            disabled: false,
            error:e,
            displaySendNotificationModal:false,
        })
        ToastStore.error(this.state.error.message);
    }) 
  }


sendItemNotFoundEmail=()=>{
  if (!this.state.email){
    ToastStore.error('Missing email address'); 
    return;
  }

  
  this.setState({
    disabled: true,
  });

   axios.post(`${SERVER_URL}/Claims/SendItemNotFoudNotificationEmail/`, {
        id:this.state.claimId,
        includeImage: this.state.includeImage

  }, {
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId()
    
    }
  })
  .then((res)=>{
      //this.props.history.push('/');
      // Show saved successful
      if(res.status!==200){
       // console.log(JSON.stringify(res));
        ToastStore.error("An error occured: " + res.response.statusText);
      }else{
        ToastStore.success('Email Sent Successfully!');
      }
      //console.log('response: ' + res);
      this.setState({
        showAlert:false,
        disabled: false,
        showSuccess: true,
        displaySendNotificationModal:false,

    })
   
   
  })
  .catch ((e)=>{
      
      this.setState({
          showAlert:true,
          disabled: false,
          error:e,
          displaySendNotificationModal:false,
      })
      ToastStore.error(this.state.error.message);
  }) 


}

  renderSendFoundNotificationButton=(claimItem)=>{
    
    var disabled =  (!claimItem || !claimItem.email ||!claimItem.id || !this.state.lostItemId) ;
      return(
        <button
        disabled= {disabled}                  
        className="btn btn-info"
       
        onClick={() => {this.setState({displaySendNotificationModal:true})}}>
        Send Found Email
      </button>
      )
    

  }
  renderSendItemNotFoundNotificationButton=(claimItem)=>{
    
    var disabled =  (!claimItem || !claimItem.email ||!claimItem.id || this.state.lostItemId) ;
      return(
        <button
        disabled= {disabled}                  
        className="btn btn-outline-danger btn-sm"
       
        onClick={() => {this.sendItemNotFoundEmail()}}>
        Send Item Not Found Email
      </button>
      )
    

  }

  renderShippingButtons=(claimItem)=>{
    var enabled = (claimItem && claimItem.shipments && claimItem.shipments.length > 1);
    var hasSuccessfulTransaction = false;
    var shippoURL  = '';
    var commercialURL = '';

    if (enabled){
      for(var i=0; i < claimItem.shipments.length; i++){
        let shipment = claimItem.shipments[i];
        if (shipment.shippoTransactionCompleteJSON ){
          let shippo = JSON.parse(shipment.shippoTransactionCompleteJSON);
          if (shippo.status==='SUCCESS'){
           
            hasSuccessfulTransaction = true;
            shippoURL=shippo.label_url;
            commercialURL=shippo.commercial_invoice_url;
            break;
          }
        }

     }
     
    
    }


    return (
      <div><p className="text-success">Shipping label is ready!  </p>
              <button
                  disabled={!hasSuccessfulTransaction}
                  className="btn btn-outline-info sm "
                  onClick={() => {this.printShipping(shippoURL)}}>
                  Print Shipping Label
                </button>
                <button
                  disabled={!hasSuccessfulTransaction}
                  className="btn btn-outline-info sm"
                  onClick={() => {this.printShipping(commercialURL)}}>
                 Commercial Invoice (intl)
                </button>
                 <button
                  disabled={!hasSuccessfulTransaction}
                  className="btn btn-outline-success sm"
                  onClick={() => {this.createLetter()}}>
                  Print Return Letter
                </button>

                </div>
        
      );

  }

  renderShippingInformation = (claimItem)=>{
    
    if (!claimItem || !claimItem.shipments) { return (null); }
    let printingButtonList = [];
    // add parent
  
    // Walk through each item in the Shipments
    for(var i=0; i < claimItem.shipments.length; i++){
        let shipment = claimItem.shipments[i];
        let itemIndex = i + 1;
        //console.log(shipment);
        if (shipment.shippoTransactionCompleteJSON ){
          let shippo = JSON.parse(shipment.shippoTransactionCompleteJSON);
         
          if (shippo.status==='SUCCESS'){
          
              printingButtonList.push(
               
                <li className="list-group-item d-flex justify-content-start" key={i}>
                    <span style={{width:24, height:24, fontSize: '12px', color:'white'}} className="badge bg-success ">{itemIndex}</span>
                    
                    <button style={{marginLeft:'18px'}} className="btn btn-outline-info btn-sm" onClick={() => {this.printShipping(shippo.label_url)}}>Print Shipping Label</button>
                    <button style={{marginLeft:'10px'}} className="btn btn-outline-info btn-sm" disabled={(shippo.commercial_invoice_url) ? false : true} onClick={() => {this.printShipping(shippo.commercial_invoice_url)}}>Commercial Invoice (intl)</button>     
                    <button style={{marginLeft:'10px'}} className="btn btn-outline-success btn-sm" onClick={() => {this.createLetter()}}>Print Return Letter</button>
               </li>
            

              )
          }else{
            // An error occured and needs to be displayed
            
            let errorMessage = "";
            
            // Do not assume shippo has responses
            if (shippo.messages && shippo.messages.length > 0){
              for (var m=0; m < shippo.messages.length; m++){
                errorMessage = errorMessage + shippo.messages[m].text + "\n";
              }
            }
           
                     

           
            printingButtonList.push(
              <li className="list-group-item d-flex justify-content-start" key={i}>
                  <span style={{width:24, height:24, fontSize: '12px', color:'white'}} className="badge bg-danger ">{itemIndex}</span>
                  <button style={{color:'#d9534f', cursor:'pointer'}} className="btn btn-link-danger btn-sm" onClick={() => {alert(errorMessage)}}>{"An Error Occured. Request sent on " +  this.formatDate(shipment.createdAt) + " Click for details."}</button>
    
              </li>


            )
          }
        }else{
          let emailOrPhone = "";
          if (shipment.shipmentRequestJSON){
            let shipREquest = JSON.parse(shipment.shipmentRequestJSON);
            if (shipREquest){
              emailOrPhone = shipREquest.email;
            }
          }
          // Waiting on purchase for shipping label
          printingButtonList.push(

            <li className="list-group-item d-flex justify-content-start" key={i}>
              <span style={{width:24, height:24, fontSize: '12px', color:'white'}} className="badge bg-info ">{itemIndex}</span>
              <span className="text-info" style={{fontSize: '10px', paddingLeft:20}}><b>{'Waiting for customer to order label. Request sent on ' + this.formatDate(shipment.createdAt) + ' Sent To: ' + emailOrPhone}</b></span>
            </li>


       )
        }
    }
       


    return(
      <div>
        <span className="text-secondary text-centered">Shipping activity log and return signature:</span>
      <ul className="list-group">
         {printingButtonList.map((item)=>{
            return(item)
         })}
          
      </ul>
      </div>
    )
   
   

  }
  renderShippingInformationOLD=(claimItem)=>{
    
    if (!claimItem || !claimItem.shipments) { return (null); }
   

    var message= '';
      //console.log(JSON.stringify(claimItem));
      if (claimItem.shipments.length > 1){
        for(var i=0; i < claimItem.shipments.length; i++){
            let shipment = claimItem.shipments[i];
            
            if (shipment.shippoTransactionCompleteJSON ){
              let shippo = JSON.parse(shipment.shippoTransactionCompleteJSON);
              if (shippo.status==='SUCCESS'){
               
                return (
                  <div><p className="text-success">Shipping label is ready!  </p>
                          <button
                              
                              className="btn btn-outline-info "
                              onClick={() => {this.printShipping(shippo.label_url)}}>
                              Print Shipping Label
                            </button>
                            <button
                              
                              className="btn btn-outline-info "
                              onClick={() => {this.printShipping(shippo.commercial_invoice_url)}}>
                             Commercial Invoice (intl)
                            </button>
                             <button
                              
                              className="btn btn-outline-success "
                              onClick={() => {this.createLetter()}}>
                              Print Return Letter
                            </button>

                            </div>
                    
                  );
                 
              }
            }
          }
      // NO ITEMS WERE PURCHASED
      return (<div><p className="text-danger">Sent {claimItem.shipments.length} requests but some labels where purchased by customer</p></div>);
    

         
      }else if(claimItem.shipments.length === 1) {
        var shipment = claimItem.shipments[0];
        if (shipment.shippoTransactionCompleteJSON ){
          var shippo = JSON.parse(shipment.shippoTransactionCompleteJSON);
          if (shippo.status==='SUCCESS'){
            // show print label
            return (
            <div><p className="text-success">Shipping label is ready!  </p>
             <button
                        
                        className="btn btn-outline-info  btn-sm"
                        onClick={() => {this.printShipping(shippo.label_url)}}>
                        Print Shipping Label
                      </button>
                      <button
                              
                              className="btn btn-outline-info  btn-sm"
                              onClick={() => {this.printShipping(shippo.commercial_invoice_url)}}>
                             Commercial Invoice (intl)
                            </button>
                            <button
                              
                              className="btn btn-outline-success  btn-sm"
                              onClick={() => {this.createLetter()}}>
                              Print Return Letter
                            </button>
                      </div>
            );
            
           
          }else{
            // show customer error
            return (<div><p className="text-error">An error occured while customer ordered the shipping label. Click here for details.</p></div>);
           
          }
        }else{

          message= 'Waiting for customer to order label. Request sent on ' + this.formatDate(shipment.createdAt);
          return (<div><p className="text-danger">{message}</p></div>);
        }
        
      }
    
    return (
    
    
    
    <div> <p className="text-success">{this.state.shippingInformation}</p></div>
    
  
      
  
  
  
    )
  }
  // existing claims  
  onOpenReturnModal = () => {
    this.setState({ showNewReturn: true });
  };
 
  onCloseReturnModal = () => {
    this.setState({ showNewReturn: false });
  };

  renderModalView=()=>{

    return(
     
      <div style={{margin:'5px'}} >
    
      
       {this.renderToast()}
  
       <div class="jumbotron ">
         
             <div className="row">

                   <div className='col'> 
                     <h3 >CLAIM: {(this.state.claimId) ? this.state.claimId : 'NEW'}</h3>
                   
                  </div>

                    
                   <div className='col'> 
                     <h5 className="text-danger text-right"><b>Status:</b> {this.claimStageDesc(this.state.status)} </h5> 
                 </div>
                     
          </div>
          <div className="row">
                 <div className='col '> 
                     <h6 >CLAIMED BY: {(this.state.lastName) ? this.state.lastName + ',' + this.state.firstName : 'NEW'}</h6>
                   
                  </div>
                 </div>


              
         </div>
            <div className="row">   
                 <div className="col-md">
                 <h5>DETAILS</h5> <br/>  

                  <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1">Claim Date:</label>
                  
                          <DatePicker
                              className="form-control"
                              onChange={this.onClaimDateChange}
                              name="claimDate"
                              selected={this.state.claimDate}
                              autoComplete='off'
                            />
                          </div>
                          <div className="col">
                      
                          <Toggle id='isVIP' labelRight="VIP Guest?" checked={this.state.isVIP} onToggle={value => this.setState({isVIP:value})} /> 

                          </div>
                  </div>


                

                    <form>
                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>First (required) :</label>
                          <input
                                           disabled={this.state.disabled}
                                           type="text"
                                           onChange={this.handleInputChange}
                                           name="firstName"
                                           className="form-control"
                                           placeholder="First Name"
                                           value= {this.state.firstName}
                                           autoComplete='off'
                                         />
                          </div>
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Last (required):</label>
                          <input
                                           disabled={this.state.disabled}
                                           type="text"
                                           onChange={this.handleInputChange}
                                           name="lastName"
                                           className="form-control"
                                           placeholder="Last Name"
                                           value= {this.state.lastName}
                                           autoComplete='off'
                                         />
                          </div>
                        </div>


                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Email :</label>
                                         <input
                                           disabled={this.state.disabled}
                                           type="email"
                                           onChange={this.handleInputChange}
                                           name="email"
                                           className="form-control"
                                           placeholder="Please provide an email."
                                           value= {this.state.email}
                                           autoComplete='off'
                                         />
                          </div>
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Phone:</label>
                                         <input
                                           disabled={this.state.disabled}
                                           type="text"
                                           onChange={this.handleInputChange}
                                           name="phone"
                                           className="form-control"
                                           placeholder="Please provide a phone number."
                                           value= {this.state.phone}
                                           autoComplete='off'
                                         />
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Shipping Address:</label>
                                         <input
                                           disabled={this.state.disabled}
                                           type="text"
                                           name="shippingAddress"
                                           onChange={this.handleInputChange}
                                           className="form-control"
                                           placeholder="Please provide an address if shipping this item"
                                           value= {this.state.shippingAddress}
                                           autoComplete='off'
                                         />
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Shipping Address2 :</label>
                                         <input
                                           disabled={this.state.disabled}
                                           type="text"
                                           name="shippingAddress2"
                                           onChange={this.handleInputChange}
                                           className="form-control"
                                           placeholder="Please provide an address if shipping this item"
                                           value= {this.state.shippingAddress2}
                                           autoComplete='off'
                                         />
                          </div>
                        </div>
                       

                                     <div className='form-row'>
                                            <div className='col-4'>
                                                <label htmlFor="shippingCity" className='text-primary'> City </label>
                                              <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="shippingCity"
                                                className="form-control"
                                                placeholder=""
                                                value= {this.state.shippingCity}
                                                autoComplete='off'
                                              />    

                                            </div>
                                            <div className='col'>
                                            <label htmlFor="shippingState" className='text-primary'> State / Prov.:</label>
                                              <select
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="shippingState"
                                                className="custom-select"
                                                placeholder=""
                                                value= {this.state.shippingState}
                                                autoComplete='off'
                                              > 
                                              {stateAbbreviations.map(item => (
                                                <option key={item} value={item}>
                                                  {item}
                                                </option>
                                              ))}
                                              </select>   
                                            </div>
                                            <div className='col-4'>
                                                <label htmlFor="shippingPostalCode" className='text-primary'> Postal Code :</label>
                                              <input
                                                disabled={this.state.disabled}
                                                type="numeric"
                                                onChange={this.handleInputChange}
                                                name="shippingPostalCode"
                                                className="form-control"
                                                placeholder=""

                                                value= {this.state.shippingPostalCode}
                                                autoComplete='off'
                                              />   

                                            </div>
                                        </div>
  
                                        <label htmlFor="shippingCountry" className='text-primary'> Country :</label>
                                          <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="shippingCountry"
                                            className="custom-select"
                                            placeholder=""
                                            value= {this.state.shippingCountry}
                                            autoComplete='off'
                                          > 
                                          {isoCountries.map(item => (
                                            <option key={item.ccode} value={item.ccode}>
                                              {item.cname}
                                            </option>
                                          ))}

                                          </select>   
                        <br/>                
                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1">Claim Details</label>
                                         <textarea
                                           disabled={this.state.disabled}
                                           type="text"
                                           name="details"
                                           onChange={this.handleInputChange}
                                           className="form-control"
                                           placeholder="Customer's description."
                                           value= {this.state.details}
                                           autoComplete='off'
                                         />
                          </div>
                        </div>

                      <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1">Status:</label>
                                      
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col">
                          <select className='custom-select'  value={this.state.status} name='status' onChange={this.handleInputChange}>
                                          <option value="A">Archived</option>
                                          <option value="O">Open</option>
                                          <option value="LABELREQUESTED">Label Requested </option>
                                          <option value="WS">Waiting To Ship</option>
                                          <option value="WP">Waiting For Pickup</option>
                                          <option value="CS">Closed-Shipped</option>
                                          <option value="CP">Closed-Pickedup</option>

                                          
                                        </select>
                                      
                          </div>
                          <div className="col">
                          <label htmlFor="archiveReason" className='text-primary'>Archive Reason:</label>
                                         <input
                                           disabled={(this.state.status!=='A')}
                                           type="text"
                                           name="archiveReason"
                                           onChange={this.handleInputChange}
                                           className="form-control"
                                           placeholder=""
                                           value= {this.state.archiveReason}
                                           autoComplete='off'
                                         />
                          </div>

                        </div>
                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Travel Date :</label>
                                               <DatePicker
                                                 className="form-control"
                                                 onChange={this.ontravelDateChange}
                                                 name="travelDate"
                                                 selected={this.state.travelDate}
                                                 autoComplete='off'
                                               />
                          </div>
                        </div>

                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Pickup Date :</label>
                                               <DatePicker
                                                 className="form-control"
                                                 onChange={this.onPickupDateChange}
                                                 name="pickupDate"
                                                 selected={this.state.pickupDate}
                                                 autoComplete='off'
                                               />
                                      
                          </div>
                          <div className='col'> 
                          <label htmlFor="exampleInputEmail1" className='text-primary'>Ship Date :</label><br/>
                                               <DatePicker
                                                 className="form-control"
                                                 onChange={this.onShipDateChange}
                                                 name="shipDate"
                                                 selected={this.state.shipDate}
                                                 autoComplete='off'
                                               />
                                      
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col">
                          <label htmlFor="note" className='text-primary'>Note(s) :</label>
                          <textarea
                                           disabled={(this.state.disabled)}
                                           type="text"
                                           name="note"
                                           rows="4"
                                           onChange={this.handleInputChange}
                                           className="form-control"
                                           placeholder=""
                                           value= {this.state.note}
                                           autoComplete='off'
                                         />
                          </div>
                        </div>

                       
                      </form>

                                       
                                       
                       </div>

              </div>
                
           
            <br/>

               <div className="row">   
              
                <div className="col-md">
                <button
                       disabled={this.state.disabled || auth0Client.lfReadOnly===true}
                       className="btn btn-primary"
                       onClick={() => {this.submit()}}>
                       Update
                     </button>
                </div>
               
               

               </div>
        
                    

       

     </div>
       
    );


  }

renderRequestShippingbutton=()=>{
  
      if (this.state.lostItemId){
      return (
        <button
         disabled = {this.state.disableRequestShippingLabel || auth0Client.lfReadOnly===true}
        className="btn btn-success"
        onClick={() => {this.createReturn()}}>
       Request Shipping Label
      </button>


      )
    }else{
      return ( <p className='text-primary text-center'>Assign a lost item above to request shipping </p> );

    }
}
renderPrintFormLetter=()=>{
  if (this.state.lostItemId){
    return (
      <button
     
      className="btn btn-outline-success  btn-sm"
      onClick={() => {this.createLetter()}}>
     Print Return Letter
    </button>


    )
  }else{
    return ( null );

  }
}

createLetter=()=>{

  // Axios Post
  axios.post(`${SERVER_URL}/Claims/GetFormLetter/`, {
    id:this.state.claimId,
  

}, {
headers: { 
  'Authorization': `Bearer ${auth0Client.getIdToken()}`,
  'venueId': auth0Client.getActiveVenuedId()

}
})
.then((res)=>{
  //this.props.history.push('/');
  // Show saved successful
  if(res.status!==200){
   // console.log(JSON.stringify(res));
    ToastStore.error("An error occured: " + res.response.statusText);
  }else{
    var win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=1024,top=50,left=500");
    //console.log(res);
    win.document.body.innerHTML = res.data;
    //window.open(url);
  }
  //console.log('response: ' + res);
  this.setState({
    showAlert:false,
    disabled: false,
    showSuccess: true,

})


})
.catch ((e)=>{
  
  this.setState({
      showAlert:true,
      disabled: false,
      error:e,

  })
  ToastStore.error(this.state.error.response);
}) 



 
}


renderVenueTypeSection=()=>{
  if (this.state.venueTypeCd==='A'){
    return (
      this.renderAirlineLocation()
    )
  }else if (this.state.venueTypeCd==='S'){
    return (
      this.renderStadiumLocation()
    )
  }
}



renderStadiumLocation=()=>{

  return(
<div >
    <h5> Stadium Location Detail </h5> <br/>

        <div className="form-group">
        <div className='row'>
            <div className='col'>
            <label htmlFor="Section" className='text-primary'>Section or Box:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="section"
                              className="form-control"
                              placeholder="The section# or box name"
                              value= {this.state.section}
                              autoComplete='off'
                            />
            </div>
            <div className='col'>
            <label htmlFor="Row" className='text-primary'>Row:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="row"
                              className="form-control"
                              placeholder="The row where the item was found"
                              value= {this.state.row}
                              autoComplete='off'
                            />
            </div>
            <div className='col'>
            <label htmlFor="Seat" className='text-primary'>Seat:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="seat"
                              className="form-control"
                              placeholder="The seat where the item was found"
                              value= {this.state.seat}
                              autoComplete='off'
                            />
            </div>


        </div>
        <div className='row'>
            <div className='col'>
            <label htmlFor="parkingLot" className='text-primary'>Parking Lot:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="parkingLot"
                              className="form-control"
                              placeholder="Parking Lot"
                              value= {this.state.parkingLot}
                              autoComplete='off'
                            />
            </div>
            <div className='col'>
            
            </div>


        </div>
    </div>
  </div>
  )

}



renderAirlineLocation=()=>{

  //if (this.state.venueTypeCd==='A'){

    return (

    <div className="col-12">
    <h5> Aviation Location Detail </h5> <br/>

        <div className="form-group">
        <div className='row'>
            <div className='col-4'>
            <label htmlFor="airportCd" className='text-primary'>Airport Code:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="airportCd"
                              className="form-control"
                              placeholder="i.e. ORD"
                              value= {this.state.airportCd}
                              autoComplete='off'
                            />
            </div>
            <div className='col-4'>
            <label htmlFor="terminal" className='text-primary'>Terminal:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="terminal"
                              className="form-control"
                              placeholder=""
                              value= {this.state.terminal}
                              autoComplete='off'
                            />
            </div>
            <div className='col-4'>
            <label htmlFor="gate" className='text-primary'>Gate/Lounge:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="gate"
                              className="form-control"
                              placeholder=""
                              value= {this.state.gate}
                              autoComplete='off'
                            />
            </div>


        </div>
        <div className='row'>
            <div className='col-4'>
            <label htmlFor="flightNumber" className='text-primary'>Flight(#):</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="flightNumber"
                              className="form-control"
                              placeholder="i.e. UAL 234"
                              value= {this.state.flightNumber}
                              autoComplete='off'
                            />
            </div>
            <div className='col-4'>
            <label htmlFor="seat" className='text-primary'>Seat:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="seat"
                              className="form-control"
                              placeholder="Seat or row"
                              value= {this.state.seat}
                              autoComplete='off'
                            />
            </div>


        </div>
    </div>
  </div>

    )

}
renderSignature=()=>{

  return(
   <div >
       <h5>Signature </h5> <br/>
       <div className='col-12' style={{borderStyle:'solid', borderColor:'gray', borderWidth:'1px', width:'100%', height:'100px'}}>
              <img src='' alt='' onClick={()=>{this.setState({largeImageUrl:this.state.signUrl, displayLargeImageModal:true})}}/>

        </div>

    </div>   
   
  )
}

sendEmail=()=>{
  if (this.state.email){
    window.location.href= 'mailto:' + this.state.email;
  }
}

// Renders the contact information area

renderContactSection=()=>{

    return (
      <div className="form-group">
                     
  
    
      <div className='form-row'>
          <div className='col-6'>
                <label htmlFor="firstName" className='text-danger'>First Name (required):</label>
                            <input
                             autoComplete='off'
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="firstName"
                              className="form-control"
                              placeholder=""
                              value= {this.state.firstName}
                             
                            />
          </div>
          <div className='col-6'>
                          <label htmlFor="lastName" className='text-danger'>Last Name (required):</label>
                            <input
                            autoComplete='off'
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="lastName"
                              className="form-control"
                              placeholder=""
                              value= {this.state.lastName}
                              
                            />
            </div>

    </div>
     
      <div className='form-row'>
        <div className='col-6'>
                          
                        <label htmlFor="email" className='text-primary'>Email :</label>
                        <div className='input-group mb-3'>
                        <input
                            disabled={this.state.disabled}
                            type="email"
                            onChange={this.handleInputChange}
                            name="email"
                            className="form-control"
                            placeholder=""
                            value= {this.state.email || ''}
                            autoComplete='off'
                          />
                         <button className="btn btn-sm btn-primary" disabled={(!this.state.email)} type="button" id="button-addon2" onClick={()=>this.sendEmail()}>
                        email
                         </button>
                        </div>
                       
        </div>
       <div className='col-6'>
                        <label htmlFor="phone" className='text-primary'>Phone:</label>
                        <input
                          disabled={this.state.disabled}
                          type="phone"
                          onChange={this.handleInputChange}
                          name="phone"
                          className="form-control"
                          placeholder=""
                          value= {this.state.phone || ''}
                          autoComplete='off'
                        />
         </div>
       </div>

        <div className='form-row'>
            <div className='col-6'>
            <label htmlFor="shippingAddress">Shipping Address:</label>
                        <input
                          disabled={this.state.disabled}
                          type="text"
                          name="shippingAddress"
                          onChange={this.handleInputChange}
                          className="form-control"
                          placeholder=""
                          value= {this.state.shippingAddress || ''}
                          autoComplete='off'
                        />
            </div>

             <div className='col-6'>
             <label htmlFor="exampleInputEmail1">Shipping Address2:</label>
                       <input
                         disabled={this.state.disabled}
                         type="text"
                         name="shippingAddress2"
                         onChange={this.handleInputChange}
                         className="form-control"
                         placeholder=""
                         value= {this.state.shippingAddress2 || ''}
                         autoComplete='off'
                       />
             </div>
        </div>

                      
                     

        <div className='form-row'>
                          <div className='col-6'>
                              <label htmlFor="shippingCity" className='text-primary'> City:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="shippingCity"
                              className="form-control"
                              placeholder=""
                              value= {this.state.shippingCity || ''}
                              autoComplete='off'
                            />    

                          </div>
                          <div className='col-6'>
                          <label htmlFor="shippingState" className='text-primary'> State:</label>
                          <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="shippingState"
                              className="form-control"
                              placeholder=""

                              value= {this.state.shippingState || ''}
                              autoComplete='off'
                            />   

                            
                         
                          </div>
                        
          </div>
           
          <div className='form-row'>
             <div className='col-6'>
                              <label htmlFor="shippingPostalCode" className='text-primary'> Postal Code:</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="shippingPostalCode"
                              className="form-control"
                              placeholder=""

                              value= {this.state.shippingPostalCode || ''}
                              autoComplete='off'
                            />   

                </div>
                <div className='col-6'>   

                      <label htmlFor="shippingCountry" className='text-primary'> Country :</label>
                        <select
                          disabled={this.state.disabled}
                          type="text"
                          onChange={this.handleInputChange}
                          name="shippingCountry"
                          className="custom-select"
                          placeholder=""
                          value= {this.state.shippingCountry || ''}
                          autoComplete='off'
                        > 
                        {isoCountries.map(item => (
                          <option key={item.ccode} value={item.ccode}>
                            {item.cname}
                          </option>
                        ))}
                        </select>   
                </div>
            </div>
            <div className="row" style={{padding:10}}>
            <div className="col">
              {(this.state.picUrl) && 
              <div className="row">
                <div className="col">
                  <label htmlFor="picUrl" className='text-primary'>Claim Image from Guest:</label>
                </div>
                <div className="col">
                  <img style={{maxWidth:250, width:"250",maxHeight:150, height:"150", alignContent:'center'}} src={this.state.picUrl} onClick={()=>{this.setState({largeImageUrl:this.state.picUrl, displayLargeImageModal:true})}} alt=' '/> 
                </div>
              </div>
              }

              
            </div>
          
          </div>
          <div className="row" style={{padding:10}}>
            <div className="col">
              <Toggle id='isVIP' labelRight="VIP Guest?" checked={this.state.isVIP || false} onToggle={value => this.setState({isVIP:value})} /> 
            </div>
          </div>
          </div>
         
                 
             
      
    )

}

renderSignature =()=>{
    //  console.log(this.state.signUrl);
  if (this.state.signUrl===undefined || this.state.signUrl===''){
  
    return(
      <h5> </h5>
    )}else{
    
      return (

        <div className='row'>
           <div className='col'>
           <img style={{ maxWidth:250, width:"250",maxHeight:150, height:"150", alignContent:'center'}} src={this.state.signUrl} onClick={()=>{this.setState({largeImageUrl:this.state.signUrl, displayLargeImageModal:true})}} alt=' '/> 
          </div>
          <div className='col text-center'>
                {this.renderReturnImage()}
          </div>

        </div>
       
          
      
       
      
      
      )
    }
  }
renderReturnImage=()=>{
   if (this.state.returnImageUrl){
    return(
      
      <img style={{maxWidth:75, width:"75",maxHeight:75, height:"75", alignContent:'center'}} onClick={()=>{this.setState({largeImageUrl:this.state.returnImageUrl, displayLargeImageModal:true})}} src={this.state.returnImageUrl} alt=' '/> 
      )
   } 
}


renderDetailsSection=()=>{

return (
  <div>
      <div className='row'>
        <div className="col-6">
                <label htmlFor="exampleInputEmail1">Claim Date:</label>
                <br/>
                <DatePicker
                    className="form-control"
                    onChange={this.onClaimDateChange}
                    name="claimDate"
                    selected={this.state.claimDate}
                    autoComplete='off'
                  />
          </div>
          <div className="col-6">
          <label htmlFor="exampleInputEmail1" className='text-primary'>Travel Date :</label>
                          <br/>
                                               <DatePicker
                                                 className="form-control"
                                                 onChange={this.ontravelDateChange}
                                                 name="travelDate"
                                                 selected={this.state.travelDate}
                                                 autoComplete='off'
                                               />
              
              </div>
    </div>
    <div className="form-row">
            <div className="col">
            <label htmlFor="exampleInputEmail1" className='text-primary'>Status:</label>
                                  
                                  <select className='custom-select'  value={this.state.status} name='status' onChange={this.handleInputChange}>
                                    <option value="A">Archived</option>
                                    <option value="O">Open</option>
                                    <option value="LABELREQUESTED">Label Requested </option>
                                    <option value="WP">Waiting For Pickup</option>
                                    <option value="CS">Closed-Shipped</option>
                                    <option value="CP">Closed-Pickedup</option>
                                    <option value="READYTOSHIP">Ready To Ship</option>
                                    <option value="REQUESTTOSHIP">Request To Ship</option>
                                    
                                  </select>
            </div>
            <div className="col">
                          <label htmlFor="archiveReason" className='text-primary'>Archive Reason:</label>
                                         <input
                                           disabled={(this.state.status!=='A')}
                                           type="text"
                                           name="archiveReason"
                                           onChange={this.handleInputChange}
                                           className="form-control"
                                           placeholder=""
                                           value= {this.state.archiveReason}
                                           autoComplete='off'
                                         />
              </div>
    </div>

    <div className='row'>
                <div className='col'> <label htmlFor="exampleInputEmail1">Pickup Date :</label>
                <br/>
                    <DatePicker
                      className="form-control"
                      onChange={this.onPickupDateChange}
                      name="pickupDate"
                      selected={this.state.pickupDate}
                      autoComplete='off'
                    />
                  </div>
                <div className='col'> <label htmlFor="exampleInputEmail1">Ship Date :</label>
                <br/>
                    <DatePicker
                      className="form-control"
                      onChange={this.onShipDateChange}
                      name="shipDate"
                      selected={this.state.shipDate}
                      autoComplete='off'
                    />
              </div>

      </div>
      <div className="form-row">
                          <div className="col">
                          <label htmlFor="note" className='text-primary'>Note(s) :</label>
                          <textarea
                                           disabled={(this.state.disabled)}
                                           type="text"
                                           name="note"
                                           rows="4"
                                           onChange={this.handleInputChange}
                                           className="form-control"
                                           placeholder=""
                                           value= {this.state.note}
                                           autoComplete='off'
                                         />
                          </div>
      </div>
      <div className="form-row" style={{padding:10}}>
                          <div className="col">
                              <Toggle id='isReviewed' labelRight="Claim reviewed" checked={this.state.isReviewed} onToggle={value => this.setState({
                                isReviewed:value, reviewedAt: (value) ? new Date():undefined})} /> 
                          </div>
                          <div className="col">
                            {(this.state.reviewedAt) ? ClaimFormatterFunctions.formatDateTime(this.state.reviewedAt) : ''}
                          </div>

                        </div>
      <div className="row">
        <div className='col'>
        <hr/>
        </div>
      </div>   
      <div className="row">   
                 
                  <div className='col text-left'>
                      <h5>Claim Details: </h5>
                  
                  </div>
             </div>
    <div className='row'>
        <div className="col-12">
        
          <label htmlFor="exampleInputEmail1" className='text-primary'>Describe the item. (i.e. "Engraved" or "Blue phone case"</label>
                      <textarea
                        disabled={this.state.disabled}
                        type="text"
                        name="details"
                        rows="3"
                        onChange={this.handleInputChange}
                        className="form-control"
                        placeholder=""
                        value= {this.state.details}
                        autoComplete='off'
                      />
          </div>
    </div>
   
                                      
    <div className="row ">   
      <div className="col-6">
          <label htmlFor="category" className='text-primary'>Product category:</label>
          <select
                  disabled={this.state.disabled}
                  type="text"
                  onChange={this.handleCatChange}
                  name="category"
                  className="custom-select"
                  placeholder=""
                  value= {this.state.category}
                  autoComplete='off'
                > 
                {this.state.categoriesMap.map(item =>(
                  <option key={item.name} value={item.name}>
                  {item.name}
              </option>
                ))}
                              
                                                    
                </select>   
            </div>
        <div className="col-6">
        <label htmlFor="subcat" className='text-primary'> Product Sub-category:</label>
        <select
                                        disabled={this.state.disabled}
                                        type="text"
                                        onChange={this.handleInputChange}
                                        name="subcat"
                                        className="custom-select"
                                        placeholder=""
                                        value= {this.state.subcat}
                                        autoComplete='off'
                                        
                                      > 

                                      {this.state.filterdSubItems.map(item=>(
                                        <option value={item.name} key={item.name}>
                                        {item.name}
                                        </option>
                                      ))}                            
                                      </select>   
        </div>

        </div>
        <div className='row '>
            <div className="col-6">
            <label htmlFor="brand" className='text-primary'>Brand:</label>
                                          <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="brand"
                                            className="form-control"
                                            placeholder=""
                                            value= {this.state.brand}
                                            autoComplete='off'
                                          />
            </div>
            <div className="col-6">
            <label htmlFor="color" className='text-primary'>Color:</label>
            <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="color"
                                            className="custom-select"
                                            placeholder=""
                                            value= {this.state.color}
                                            autoComplete='off'
                                          > 
                                                {colors.map(item=>(
                                                    <option value={item} key={item}>
                                                    {item}
                                                    </option>
                                                ))}              
                                          </select>   
              </div>

          </div>
          <div className='row '>
            <div className="col-6">
            <label htmlFor="locationLost" className='text-primary'>Location:</label>
                                          <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="locationLost"
                                            className="form-control"
                                            placeholder=""
                                            value= {this.state.locationLost}
                                            autoComplete='off'
                                          />
            </div>
            <div className="col-6">
            <label htmlFor="registeredGuestName" className='text-primary'>Registered Guest:</label>
                                          <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="registeredGuestName"
                                            className="form-control"
                                            placeholder=""
                                            value= {this.state.registeredGuestName}
                                            autoComplete='off'
                                          />
            </div>
            </div>

      



  </div>
  
)


}

renderMatchesButton=()=>{
  if (this.state.totalMatches > 0 && (!this.state.lostItemId)){
    return( <button className="btn btn-outline-info" type="button"  onClick={() => {
      this.props.history.push('/AIM/' + this.state.claimId );
    }}>View {this.state.totalMatches} Matche(s)</button>)
  }
}
  renderWholeScreen=()=>{
    return (

    

      <div style={{margin:'0px'}} >
       {this.renderGoBack()}
       
        {this.renderToast()}
   
        <div className="container" >
          
              <div className="row">

                    <div className='col-6 text-left'> 
                      <h5 className=' text-left'>Claim Editor - <b>Status</b>: {this.claimStageDesc(this.state.status)}</h5>
                    
                   </div>

                     
                    <div className='col-6'> 
                      <h2 className="text-primary text-right">{(this.state.lastName) ? this.state.firstName +' '+  this.state.lastName : 'NEW'}</h2> 
                  </div>
               
           </div>

           <hr/>
          
          <div className='row'>
            <div className='col-10'>
           
              {this.renderShippingInformation(this.state.claim)}
             
              {this.renderSignature()}
            </div>
            <div className='col-2'>
            <img style={{width:120, height:100}} src= {this.state.url} alt={this.state.shortDescription} onClick={()=>{this.setState({largeImageUrl:this.state.url, displayLargeImageModal:true})}} />
                    <br/>
                    {this.renderHeader()}
            </div>
          </div>

             <hr/>
          
               
         


             <div className="row">   
                  <div className="col-6 text-left">
                      <h5>Contact Information</h5> 
                  </div>
                  <div className='col-6 text-left'>
                      <h5>Claim Status ({(this.state.claimId) ? this.state.claimId : 'NEW'})</h5>
                  
                  </div>
             </div>
                  <div className="row">
                          <div className="col-6">    
                           {this.renderContactSection()}
                           { this.renderVenueTypeSection()}
                          </div>

                          <div className='col-6'>
                            {this.renderDetailsSection()}

                          </div>
                  </div>
          
                  
                  <div className='row'>
                      <div className="col-6">    
                          
                      </div>

                      <div className='col-6'>
                        
                      </div>
                  
                    </div>

              
                  
               {this.renderSendNotificationDialogue()}
             
                <br/>
                <div className="row table-active">   
               
                 <div className="col-2">
                     <button
                        disabled={this.state.disabled || auth0Client.lfReadOnly===true}
                        className="btn btn-primary"
                        onClick={() => {this.submit()}}>
                        Update
                      </button>
                 </div>
                
                 <div className='col-3 text-right'> 
                 
                    {this.renderSendNotificationButton(this.state.claim)}
                </div>
                <div className='col-3 text-right'> 
                 
                 {this.renderRequestShippingbutton()}
                </div>

                <div className='col-1 text-right'> 
                 
                 {this.renderMatchesButton()}
                </div>
                <div className='col-3 text-right'> 
                 
                 {this.renderSendFoundNotificationButton(this.state.claim)}
                </div>
           

                
                

                  

                  
            </div> 
            <br/><br/>
            <div className="row">
              <div className="col-12 text-center">
              {this.renderSendItemNotFoundNotificationButton(this.state.claim)}
              </div> 
            </div>

      </div>
        
      </div>

  
     
     
    )
  }

  

render() {

  
    const {claim, showLostItemPicker,showNewReturn, showOpenShipment} = this.state;
    if (claim === null && this.props.match.params.newflag===false) {
      return (
        
      <div className="container">
       {this.renderGoBack()}
      <br/>
      <p>Loading ...</p>

      </div>
       
    )
  }else{
    return (
      <div >
     { this.renderWholeScreen()}
            {this.renderLargeImage()}
     
          <Modal open={showLostItemPicker} onClose={this.onCloseModal} styles={{ overlay: { zIndex:"1000000" } }} center>
        
            
            <LostItemPicker assignLostItemId={this.assignLostItemId}  />
           
          </Modal>

        <Modal open={showOpenShipment} onClose={this.onCloseShippingModal} center>
          
          <ClaimShipment claim={this.state.claim} isModalDisplay={true} />
        </Modal>     
        <Modal open={showNewReturn} onClose={this.onCloseReturnModal} center>
          
          <ReturnWizard2 claim={this.state.claim} lostItemId={this.state.lostItemId} isModalDisplay={true} onClose={this.onCloseReturnModal}/>
        </Modal>  

<br/>
     </div>
    )
  }


  }
}

export default withRouter(Claim);


const isoCountries = [
  {'ccode' : 'US', 'cname' : 'United States'},
  {'ccode' : 'AF', 'cname' : 'Afghanistan'},
  {'ccode' : 'AX', 'cname' : 'Aland Islands'},
  {'ccode' : 'AL', 'cname' : 'Albania'},
  {'ccode' : 'DZ', 'cname' : 'Algeria'},
  {'ccode' : 'AS', 'cname' : 'American Samoa'},
  {'ccode' : 'AD', 'cname' : 'Andorra'},
  {'ccode' : 'AO', 'cname' : 'Angola'},
  {'ccode' : 'AI', 'cname' : 'Anguilla'},
  {'ccode' : 'AQ', 'cname' : 'Antarctica'},
  {'ccode' : 'AG', 'cname' : 'Antigua And Barbuda'},
  {'ccode' : 'AR', 'cname' : 'Argentina'},
  {'ccode' : 'AM', 'cname' : 'Armenia'},
  {'ccode' : 'AW', 'cname' : 'Aruba'},
  {'ccode' : 'AU', 'cname' : 'Australia'},
  {'ccode' : 'AT', 'cname' : 'Austria'},
  {'ccode' : 'AZ', 'cname' : 'Azerbaijan'},
  {'ccode' : 'BS', 'cname' : 'Bahamas'},
  {'ccode' : 'BH', 'cname' : 'Bahrain'},
  {'ccode' : 'BD', 'cname' : 'Bangladesh'},
  {'ccode' : 'BB', 'cname' : 'Barbados'},
  {'ccode' : 'BY', 'cname' : 'Belarus'},
  {'ccode' : 'BE', 'cname' : 'Belgium'},
  {'ccode' : 'BZ', 'cname' : 'Belize'},
  {'ccode' : 'BJ', 'cname' : 'Benin'},
  {'ccode' : 'BM', 'cname' : 'Bermuda'},
  {'ccode' : 'BT', 'cname' : 'Bhutan'},
  {'ccode' : 'BO', 'cname' : 'Bolivia'},
  {'ccode' : 'BA', 'cname' : 'Bosnia And Herzegovina'},
  {'ccode' : 'BW', 'cname' : 'Botswana'},
  {'ccode' : 'BV', 'cname' : 'Bouvet Island'},
  {'ccode' : 'BR', 'cname' : 'Brazil'},
  {'ccode' : 'IO', 'cname' : 'British Indian Ocean Territory'},
  {'ccode' : 'BN', 'cname' : 'Brunei Darussalam'},
  {'ccode' : 'BG', 'cname' : 'Bulgaria'},
  {'ccode' : 'BF', 'cname' : 'Burkina Faso'},
  {'ccode' : 'BI', 'cname' : 'Burundi'},
  {'ccode' : 'KH', 'cname' : 'Cambodia'},
  {'ccode' : 'CM', 'cname' : 'Cameroon'},
  {'ccode' : 'CA', 'cname' : 'Canada'},
  {'ccode' : 'CV', 'cname' : 'Cape Verde'},
  {'ccode' : 'KY', 'cname' : 'Cayman Islands'},
  {'ccode' : 'CF', 'cname' : 'Central African Republic'},
  {'ccode' : 'TD', 'cname' : 'Chad'},
  {'ccode' : 'CL', 'cname' : 'Chile'},
  {'ccode' : 'CN', 'cname' : 'China'},
  {'ccode' : 'CX', 'cname' : 'Christmas Island'},
  {'ccode' : 'CC', 'cname' : 'Cocos (Keeling) Islands'},
  {'ccode' : 'CO', 'cname' : 'Colombia'},
  {'ccode' : 'KM', 'cname' : 'Comoros'},
  {'ccode' : 'CG', 'cname' : 'Congo'},
  {'ccode' : 'CD', 'cname' : 'Congo, Democratic Republic'},
  {'ccode' : 'CK', 'cname' : 'Cook Islands'},
  {'ccode' : 'CR', 'cname' : 'Costa Rica'},
  {'ccode' : 'CI', 'cname' : 'Cote D\'Ivoire'},
  {'ccode' : 'HR', 'cname' : 'Croatia'},
  {'ccode' : 'CU', 'cname' : 'Cuba'},
  {'ccode' : 'CY', 'cname' : 'Cyprus'},
  {'ccode' : 'CZ', 'cname' : 'Czech Republic'},
  {'ccode' : 'DK', 'cname' : 'Denmark'},
  {'ccode' : 'DJ', 'cname' : 'Djibouti'},
  {'ccode' : 'DM', 'cname' : 'Dominica'},
  {'ccode' : 'DO', 'cname' : 'Dominican Republic'},
  {'ccode' : 'EC', 'cname' : 'Ecuador'},
  {'ccode' : 'EG', 'cname' : 'Egypt'},
  {'ccode' : 'SV', 'cname' : 'El Salvador'},
  {'ccode' : 'GQ', 'cname' : 'Equatorial Guinea'},
  {'ccode' : 'ER', 'cname' : 'Eritrea'},
  {'ccode' : 'EE', 'cname' : 'Estonia'},
  {'ccode' : 'ET', 'cname' : 'Ethiopia'},
  {'ccode' : 'FK', 'cname' : 'Falkland Islands (Malvinas)'},
  {'ccode' : 'FO', 'cname' : 'Faroe Islands'},
  {'ccode' : 'FJ', 'cname' : 'Fiji'},
  {'ccode' : 'FI', 'cname' : 'Finland'},
  {'ccode' : 'FR', 'cname' : 'France'},
  {'ccode' : 'GF', 'cname' : 'French Guiana'},
  {'ccode' : 'PF', 'cname' : 'French Polynesia'},
  {'ccode' : 'TF', 'cname' : 'French Southern Territories'},
  {'ccode' : 'GA', 'cname' : 'Gabon'},
  {'ccode' : 'GM', 'cname' : 'Gambia'},
  {'ccode' : 'GE', 'cname' : 'Georgia'},
  {'ccode' : 'DE', 'cname' : 'Germany'},
  {'ccode' : 'GH', 'cname' : 'Ghana'},
  {'ccode' : 'GI', 'cname' : 'Gibraltar'},
  {'ccode' : 'GR', 'cname' : 'Greece'},
  {'ccode' : 'GL', 'cname' : 'Greenland'},
  {'ccode' : 'GD', 'cname' : 'Grenada'},
  {'ccode' : 'GP', 'cname' : 'Guadeloupe'},
  {'ccode' : 'GU', 'cname' : 'Guam'},
  {'ccode' : 'GT', 'cname' : 'Guatemala'},
  {'ccode' : 'GG', 'cname' : 'Guernsey'},
  {'ccode' : 'GN', 'cname' : 'Guinea'},
  {'ccode' : 'GW', 'cname' : 'Guinea-Bissau'},
  {'ccode' : 'GY', 'cname' : 'Guyana'},
  {'ccode' : 'HT', 'cname' : 'Haiti'},
  {'ccode' : 'HM', 'cname' : 'Heard Island & Mcdonald Islands'},
  {'ccode' : 'VA', 'cname' : 'Holy See (Vatican City State)'},
  {'ccode' : 'HN', 'cname' : 'Honduras'},
  {'ccode' : 'HK', 'cname' : 'Hong Kong'},
  {'ccode' : 'HU', 'cname' : 'Hungary'},
  {'ccode' : 'IS', 'cname' : 'Iceland'},
  {'ccode' : 'IN', 'cname' : 'India'},
  {'ccode' : 'ID', 'cname' : 'Indonesia'},
  {'ccode' : 'IR', 'cname' : 'Iran, Islamic Republic Of'},
  {'ccode' : 'IQ', 'cname' : 'Iraq'},
  {'ccode' : 'IE', 'cname' : 'Ireland'},
  {'ccode' : 'IM', 'cname' : 'Isle Of Man'},
  {'ccode' : 'IL', 'cname' : 'Israel'},
  {'ccode' : 'IT', 'cname' : 'Italy'},
  {'ccode' : 'JM', 'cname' : 'Jamaica'},
  {'ccode' : 'JP', 'cname' : 'Japan'},
  {'ccode' : 'JE', 'cname' : 'Jersey'},
  {'ccode' : 'JO', 'cname' : 'Jordan'},
  {'ccode' : 'KZ', 'cname' : 'Kazakhstan'},
  {'ccode' : 'KE', 'cname' : 'Kenya'},
  {'ccode' : 'KI', 'cname' : 'Kiribati'},
  {'ccode' : 'KR', 'cname' : 'Korea'},
  {'ccode' : 'KW', 'cname' : 'Kuwait'},
  {'ccode' : 'KG', 'cname' : 'Kyrgyzstan'},
  {'ccode' : 'LA', 'cname' : 'Lao People\'s Democratic Republic'},
  {'ccode' : 'LV', 'cname' : 'Latvia'},
  {'ccode' : 'LB', 'cname' : 'Lebanon'},
  {'ccode' : 'LS', 'cname' : 'Lesotho'},
  {'ccode' : 'LR', 'cname' : 'Liberia'},
  {'ccode' : 'LY', 'cname' : 'Libyan Arab Jamahiriya'},
  {'ccode' : 'LI', 'cname' : 'Liechtenstein'},
  {'ccode' : 'LT', 'cname' : 'Lithuania'},
  {'ccode' : 'LU', 'cname' : 'Luxembourg'},
  {'ccode' : 'MO', 'cname' : 'Macao'},
  {'ccode' : 'MK', 'cname' : 'Macedonia'},
  {'ccode' : 'MG', 'cname' : 'Madagascar'},
  {'ccode' : 'MW', 'cname' : 'Malawi'},
  {'ccode' : 'MY', 'cname' : 'Malaysia'},
  {'ccode' : 'MV', 'cname' : 'Maldives'},
  {'ccode' : 'ML', 'cname' : 'Mali'},
  {'ccode' : 'MT', 'cname' : 'Malta'},
  {'ccode' : 'MH', 'cname' : 'Marshall Islands'},
  {'ccode' : 'MQ', 'cname' : 'Martinique'},
  {'ccode' : 'MR', 'cname' : 'Mauritania'},
  {'ccode' : 'MU', 'cname' : 'Mauritius'},
  {'ccode' : 'YT', 'cname' : 'Mayotte'},
  {'ccode' : 'MX', 'cname' : 'Mexico'},
  {'ccode' : 'FM', 'cname' : 'Micronesia, Federated States Of'},
  {'ccode' : 'MD', 'cname' : 'Moldova'},
  {'ccode' : 'MC', 'cname' : 'Monaco'},
  {'ccode' : 'MN', 'cname' : 'Mongolia'},
  {'ccode' : 'ME', 'cname' : 'Montenegro'},
  {'ccode' : 'MS', 'cname' : 'Montserrat'},
  {'ccode' : 'MA', 'cname' : 'Morocco'},
  {'ccode' : 'MZ', 'cname' : 'Mozambique'},
  {'ccode' : 'MM', 'cname' : 'Myanmar'},
  {'ccode' : 'NA', 'cname' : 'Namibia'},
  {'ccode' : 'NR', 'cname' : 'Nauru'},
  {'ccode' : 'NP', 'cname' : 'Nepal'},
  {'ccode' : 'NL', 'cname' : 'Netherlands'},
  {'ccode' : 'AN', 'cname' : 'Netherlands Antilles'},
  {'ccode' : 'NC', 'cname' : 'New Caledonia'},
  {'ccode' : 'NZ', 'cname' : 'New Zealand'},
  {'ccode' : 'NI', 'cname' : 'Nicaragua'},
  {'ccode' : 'NE', 'cname' : 'Niger'},
  {'ccode' : 'NG', 'cname' : 'Nigeria'},
  {'ccode' : 'NU', 'cname' : 'Niue'},
  {'ccode' : 'NF', 'cname' : 'Norfolk Island'},
  {'ccode' : 'MP', 'cname' : 'Northern Mariana Islands'},
  {'ccode' : 'NO', 'cname' : 'Norway'},
  {'ccode' : 'OM', 'cname' : 'Oman'},
  {'ccode' : 'PK', 'cname' : 'Pakistan'},
  {'ccode' : 'PW', 'cname' : 'Palau'},
  {'ccode' : 'PS', 'cname' : 'Palestinian Territory, Occupied'},
  {'ccode' : 'PA', 'cname' : 'Panama'},
  {'ccode' : 'PG', 'cname' : 'Papua New Guinea'},
  {'ccode' : 'PY', 'cname' : 'Paraguay'},
  {'ccode' : 'PE', 'cname' : 'Peru'},
  {'ccode' : 'PH', 'cname' : 'Philippines'},
  {'ccode' : 'PN', 'cname' : 'Pitcairn'},
  {'ccode' : 'PL', 'cname' : 'Poland'},
  {'ccode' : 'PT', 'cname' : 'Portugal'},
  {'ccode' : 'PR', 'cname' : 'Puerto Rico'},
  {'ccode' : 'QA', 'cname' : 'Qatar'},
  {'ccode' : 'RE', 'cname' : 'Reunion'},
  {'ccode' : 'RO', 'cname' : 'Romania'},
  {'ccode' : 'RU', 'cname' : 'Russian Federation'},
  {'ccode' : 'RW', 'cname' : 'Rwanda'},
  {'ccode' : 'BL', 'cname' : 'Saint Barthelemy'},
  {'ccode' : 'SH', 'cname' : 'Saint Helena'},
  {'ccode' : 'KN', 'cname' : 'Saint Kitts And Nevis'},
  {'ccode' : 'LC', 'cname' : 'Saint Lucia'},
  {'ccode' : 'MF', 'cname' : 'Saint Martin'},
  {'ccode' : 'PM', 'cname' : 'Saint Pierre And Miquelon'},
  {'ccode' : 'VC', 'cname' : 'Saint Vincent And Grenadines'},
  {'ccode' : 'WS', 'cname' : 'Samoa'},
  {'ccode' : 'SM', 'cname' : 'San Marino'},
  {'ccode' : 'ST', 'cname' : 'Sao Tome And Principe'},
  {'ccode' : 'SA', 'cname' : 'Saudi Arabia'},
  {'ccode' : 'SN', 'cname' : 'Senegal'},
  {'ccode' : 'RS', 'cname' : 'Serbia'},
  {'ccode' : 'SC', 'cname' : 'Seychelles'},
  {'ccode' : 'SL', 'cname' : 'Sierra Leone'},
  {'ccode' : 'SG', 'cname' : 'Singapore'},
  {'ccode' : 'SK', 'cname' : 'Slovakia'},
  {'ccode' : 'SI', 'cname' : 'Slovenia'},
  {'ccode' : 'SB', 'cname' : 'Solomon Islands'},
  {'ccode' : 'SO', 'cname' : 'Somalia'},
  {'ccode' : 'ZA', 'cname' : 'South Africa'},
  {'ccode' : 'GS', 'cname' : 'South Georgia And Sandwich Isl.'},
  {'ccode' : 'ES', 'cname' : 'Spain'},
  {'ccode' : 'LK', 'cname' : 'Sri Lanka'},
  {'ccode' : 'SD', 'cname' : 'Sudan'},
  {'ccode' : 'SR', 'cname' : 'Suriname'},
  {'ccode' : 'SJ', 'cname' : 'Svalbard And Jan Mayen'},
  {'ccode' : 'SZ', 'cname' : 'Swaziland'},
  {'ccode' : 'SE', 'cname' : 'Sweden'},
  {'ccode' : 'CH', 'cname' : 'Switzerland'},
  {'ccode' : 'SY', 'cname' : 'Syrian Arab Republic'},
  {'ccode' : 'TW', 'cname' : 'Taiwan'},
  {'ccode' : 'TJ', 'cname' : 'Tajikistan'},
  {'ccode' : 'TZ', 'cname' : 'Tanzania'},
  {'ccode' : 'TH', 'cname' : 'Thailand'},
  {'ccode' : 'TL', 'cname' : 'Timor-Leste'},
  {'ccode' : 'TG', 'cname' : 'Togo'},
  {'ccode' : 'TK', 'cname' : 'Tokelau'},
  {'ccode' : 'TO', 'cname' : 'Tonga'},
  {'ccode' : 'TT', 'cname' : 'Trinidad And Tobago'},
  {'ccode' : 'TN', 'cname' : 'Tunisia'},
  {'ccode' : 'TR', 'cname' : 'Turkey'},
  {'ccode' : 'TM', 'cname' : 'Turkmenistan'},
  {'ccode' : 'TC', 'cname' : 'Turks And Caicos Islands'},
  {'ccode' : 'TV', 'cname' : 'Tuvalu'},
  {'ccode' : 'UG', 'cname' : 'Uganda'},
  {'ccode' : 'UA', 'cname' : 'Ukraine'},
  {'ccode' : 'AE', 'cname' : 'United Arab Emirates'},
  {'ccode' : 'GB', 'cname' : 'United Kingdom'},
 
  {'ccode' : 'UM', 'cname' : 'United States Outlying Islands'},
  {'ccode' : 'UY', 'cname' : 'Uruguay'},
  {'ccode' : 'UZ', 'cname' : 'Uzbekistan'},
  {'ccode' : 'VU', 'cname' : 'Vanuatu'},
  {'ccode' : 'VE', 'cname' : 'Venezuela'},
  {'ccode' : 'VN', 'cname' : 'Viet Nam'},
  {'ccode' : 'VG', 'cname' : 'Virgin Islands, British'},
  {'ccode' : 'VI', 'cname' : 'Virgin Islands, U.S.'},
  {'ccode' : 'WF', 'cname' : 'Wallis And Futuna'},
  {'ccode' : 'EH', 'cname' : 'Western Sahara'},
  {'ccode' : 'YE', 'cname' : 'Yemen'},
  {'ccode' : 'ZM', 'cname' : 'Zambia'},
  {'ccode' : 'ZW', 'cname' : 'Zimbabwe'}
];
